export const defaultAlignmentData = {
  curriculum: '',
  curriculumId: '',
  domains: [],
  grades: [],
  standards: [],
  subject: '',
}
